import { useSliderContext } from '@cian/slider';
import * as React from 'react';

export const Keyboard: React.FC = () => {
  const { scrollPrev, scrollNext } = useSliderContext();

  const handleKeyPress = React.useCallback(
    (event: KeyboardEvent) => {
      switch (event.code) {
        case 'ArrowLeft':
          scrollPrev();
          break;

        case 'ArrowRight':
          scrollNext();
          break;
      }
    },
    [scrollNext, scrollPrev],
  );

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyPress, { passive: true });

    return () => document.removeEventListener('keydown', handleKeyPress);
  }, [handleKeyPress]);

  return null;
};
